export default "assets/images/carousel-arrow-white-8c67c5f6.svg";